import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const PRIVACY_POLICY_URL =
  "https://app.termly.io/document/privacy-policy/183bba8d-520b-4b8f-95f8-2263ad076a9a";
export const TERMS_OF_SERVICE_URL =
  "https://app.termly.io/document/terms-of-service/c512e903-b5e7-48d4-96f8-beaf9e34ff1a";
export const FEEDBACK_URL =
  "https://airtable.com/app8OUGAtCVQF6MlG/shrDdNbpevqkYUidA";

export const openFeedback = () => {
  window.open(FEEDBACK_URL, "_blank");
};

export const openShare = async (username) => {
  const url = `${process.env.BASE_URL}/${username}`;

  if (navigator.share) {
    navigator.share({
      title: "Share your Backup link!",
      url: url,
    });
  } else {
    copyToClipboard(url);
    alert("Copied to your clipboard.");
  }
};

export const copyToClipboard = (text, onReset = () => {}) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      setTimeout(() => onReset && onReset(), 6000); // Reset copied state after some time
    })
    .catch((err) => {
      console.error("Failed to copy:", err);
      onReset && onReset();
    });
};

export function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for iOS
  if (/iPhone|iPad|iPod/i.test(userAgent)) {
    return true;
  }

  // Check for Android
  if (/Android/i.test(userAgent)) {
    return true;
  }

  // Check for other mobile devices
  if (/Mobi|Mobile|Tablet|Opera Mini|IEMobile/i.test(userAgent)) {
    return true;
  }

  return false;
}
